module.exports = __webpack_public_path__ + "img/v3-moon.a74c7181.svg";